import { FC } from "react";
import { VscLoading } from "react-icons/vsc";
import FormContainer from "./form";
import Image from "./image";

interface Props {
    data: IPlatform["get"];
    loading: boolean;
}

const EditPlatformContainer: FC<Props> = ({ data, loading }) => {
    return (
        <div className="bg-white p-3 rounded-md mb-6 shadow-md">
            {!loading && (
                <>
                    <section className="mb-4">
                        <Image data={data} />
                    </section>

                    <FormContainer data={data} />
                </>
            )}
            {loading && (
                <div className="text-center py-8">
                    <VscLoading className="text-6xl animate-spin text-blue-600" />
                </div>
            )}
        </div>
    );
};

export default EditPlatformContainer;
